import svgPaths from "./svg-paths";

interface LogoProps {
  variant?: "logomark" | "logotype" | "horizontal" | "vertical";
  colorScheme?: "brand" | "black" | "white" | "mono-white" | "light" | "purple";
  className?: string;
  size?: number;
}

export function Logo({ variant = "horizontal", colorScheme = "brand", className = "", size = 200 }: LogoProps) {
  // brand: purple mark + black text (light backgrounds)
  // white: white mark + white text (dark backgrounds, fully mono)
  // purple: purple mark + white text (dark backgrounds, brand-forward)
  // black: black mark + black text
  // mono-white: all white
  const textColor =
    colorScheme === "purple" || colorScheme === "white" || colorScheme === "mono-white"
      ? "white"
      : "black";
  const accentColor =
    colorScheme === "mono-white" ? "white" : colorScheme === "black" ? "black" : "var(--p-epic)";
  const markColor =
    colorScheme === "black"
      ? "black"
      : colorScheme === "white" || colorScheme === "mono-white"
        ? "white"
        : "var(--p-epic)"; // brand, light, purple = purple

  if (variant === "logomark") {
    return (
      <svg className={className} width={size} height={size * 0.545} viewBox="0 0 450 245.089" fill="none">
        <path d={svgPaths.p264e1880} fill={markColor} />
      </svg>
    );
  }

  if (variant === "logotype") {
    return (
      <svg className={className} width={size} height={size * 0.162} viewBox="0 0 450 72.9958" fill="none">
        <g>
          <path d={svgPaths.p3b2d9e80} fill={textColor} />
          <path d={svgPaths.p38cf1b80} fill={textColor} />
          <path d={svgPaths.p4d23400} fill={textColor} />
          <path d={svgPaths.p1b510b00} fill={textColor} />
          <path d={svgPaths.p9ac1900} fill={textColor} />
          <path d={svgPaths.p25225b00} fill={textColor} />
        </g>
        <path d={svgPaths.p1a266500} fill={accentColor} />
      </svg>
    );
  }

  if (variant === "horizontal") {
    return (
      <svg className={className} width={size} height={size * 0.1216} viewBox="0 0 450 54.7296" fill="none">
        <g>
          <path d={svgPaths.p4a8ba00} fill={textColor} />
          <path d={svgPaths.p307d580} fill={textColor} />
          <path d={svgPaths.p155cf640} fill={textColor} />
          <path d={svgPaths.p1092ed00} fill={textColor} />
          <path d={svgPaths.p12789900} fill={textColor} />
          <path d={svgPaths.p18b48e00} fill={textColor} />
        </g>
        <path d={svgPaths.p34614700} fill={accentColor} />
        <path d={svgPaths.p397a9e80} fill={markColor} />
      </svg>
    );
  }

  // vertical
  return (
    <svg className={className} width={size} height={size * 0.747} viewBox="0 0 450 336.246" fill="none">
      <g>
        <path d={svgPaths.p5613000} fill={textColor} />
        <path d={svgPaths.p5b38b20} fill={textColor} />
        <path d={svgPaths.p2bdca00} fill={textColor} />
        <path d={svgPaths.p128f0b00} fill={textColor} />
        <path d={svgPaths.p18e56200} fill={textColor} />
        <path d={svgPaths.p26ca8500} fill={textColor} />
      </g>
      <path d={svgPaths.p153b3e80} fill={accentColor} />
      <path d={svgPaths.p264e1880} fill={markColor} />
    </svg>
  );
}